import React, { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Button, Pane, Heading } from 'evergreen-ui';
import { FiLogOut } from 'react-icons/fi';
import { 
  FaMapMarkedAlt, FaSuitcase, FaEdit, FaUserEdit, 
  FaReceipt, FaCarSide, FaSearchLocation, 
  FaPlus, FaList, FaBlog
} from 'react-icons/fa';
import './AdminMenu.css';

function AdminMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = location.state?.token;

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        if (decodedToken.role !== 'admin') {
          navigate('/error404');
        }
      } catch (error) {
        console.error('Invalid token:', error);
        navigate('/error404');
      }
    } else {
      navigate('/error404');
    }
  }, [token, navigate]);

  const createLinks = [
    { to: '/admin-destination', icon: <FaMapMarkedAlt size={20} />, text: 'New Destinations' },
    { to: '/admin-tour', icon: <FaSuitcase size={20} />, text: 'New Tours' },
    { to: '/admin-carhire', icon: <FaCarSide size={20} />, text: 'New Car Hires' },
    { to: '/admin-products', icon: <FaPlus size={20} />, text: 'New Products' },
    { to: '/admin-pickup-point', icon: <FaSearchLocation size={20} />, text: 'New Pickup Points' },
    { to: '/admin-blog', icon: <FaBlog size={20} />, text: 'New Blogs' },
  ];

  const editLinks = [
    { to: '/carhire-edit', icon: <FaCarSide size={20} />, text: 'Edit Car Hires' },
    { to: '/destination-edit', icon: <FaEdit size={20} />, text: 'Edit Destinations' },
    { to: '/tour-edit', icon: <FaEdit size={20} />, text: 'Edit Tours' },
    { to: '/user-edit', icon: <FaUserEdit size={20} />, text: 'Edit Users' },
    { to: '/blog-edit', icon: <FaBlog size={20} />, text: 'Edit Blogs' },
  ];

  const viewLinks = [
    { to: '/admin-orders', icon: <FaList size={20} />, text: 'View Orders' },
    { to: '/booked-receipts', icon: <FaReceipt size={20} />, text: 'View Receipts' },
  ];

  const otherLinks = [
    { 
      to: '/login', 
      icon: <FiLogOut size={20} />, 
      text: 'Log Out',
      onClick: () => {
        localStorage.removeItem('token');
        window.location.href = "/login";
      }
    },
  ];

  const renderLinkSection = (links, title) => (
    <Pane 
      elevation={1}
      padding={16}
      borderRadius={8}
      background="tint1"
      className="link-section"
      width="100%"
      maxWidth={300}
    >
      <Heading size={600} marginBottom={12} textAlign="center">
        {title}
      </Heading>
      <Pane 
        height={1} 
        background="gray300" 
        marginY={12} 
        className="divider"
      />
      <Pane display="flex" flexDirection="column" gap={8}>
        {links.map((link, index) => (
          <Link
            key={index}
            to={link.to}
            style={{ textDecoration: 'none' }}
            onClick={link.onClick}
          >
            <Button
              appearance="primary"
              intent="success"
              className="admin-btn"
              height={56}
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={8}
            >
              {link.icon}
              <span>{link.text}</span>
            </Button>
          </Link>
        ))}
      </Pane>
    </Pane>
  );

  return (
    <Pane 
      padding={32}
      display="flex"
      flexDirection="column"
      alignItems="center"
      background="tint2"
      minHeight="100vh"
    >
      <Heading size={800} marginBottom={24}>
        Admin Dashboard
      </Heading>
      <Pane
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        gap={24}
        maxWidth={1200}
        width="100%"
      >
        {renderLinkSection(createLinks, 'Create')}
        {renderLinkSection(editLinks, 'Edit')}
        {renderLinkSection(viewLinks, 'View')}
        {renderLinkSection(otherLinks, 'Other')}
      </Pane>
    </Pane>
  );
}

export default AdminMenu;